import apiClient from './ApiClient';

// API to get salary advance transaction data
export const getSalaryAdvanceTransactions = async (filter = {}) => {
  try {
    const response = await apiClient.post('/api/SalaryAdvanceTransaction/get', {
      employee_Id: filter.employee_Id || null,
      fromDate: filter.fromDate || null,
      toDate: filter.toDate || null,
      transactionType: filter.transactionType || null,
      business_Id: filter.business_Id || null,
      branch_Id: filter.branch_Id || null,
      department_Id: filter.department_Id || null
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching salary advance transactions:", error);
    throw error;
  }
};

// API to export salary advance transaction report to Excel
export const exportSalaryAdvanceTransactionToExcel = async (filter = {}) => {
  try {
    const response = await apiClient.post('/api/SalaryAdvanceTransaction/export-excel', {
      employee_Id: filter.employee_Id || null,
      fromDate: filter.fromDate || null,
      toDate: filter.toDate || null,
      transactionType: filter.transactionType || null,
      business_Id: filter.business_Id || null,
      branch_Id: filter.branch_Id || null,
      department_Id: filter.department_Id || null
    }, {
      responseType: 'blob'
    });
    
    // Create download link
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `SalaryAdvanceTransactionReport_${new Date().toISOString().slice(0,19).replace(/[-:]/g, '').replace('T', '_')}.xlsx`);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
    
    return true;
  } catch (error) {
    console.error("Error exporting salary advance transaction report:", error);
    throw error;
  }
};






